import React from "react";

import { ErrorScreen } from "../atoms";

export const NotFoundPage: React.FC = () => (
  <ErrorScreen message="No encontramos la página que estás buscando" />
);
